export const {
  API_URL,
  APP_URL,
  API_KEY,
  APP_NAME,
  ENV_NAME,
  SENTRY_DSN,
  GOOGLE_API_KEY,
  GOOGLE_CLIENT_ID,
  MICROSOFT_CLIENT_ID,
  APP_SUPPORT_EMAIL,
  AUTH_TYPE,
} = window.__ENV__;

// The domain projects live under: <slug>.APP_DOMAIN.
//
// Three screens print a project's address, and when APP_DOMAIN is unset
// they printed "my-project." — a slug, a dot, and nothing. Deriving it
// from APP_URL keeps the address true everywhere: "console.hauser.md"
// serves projects at "<slug>.hauser.md", and a dev console on
// localhost:2405 serves them at "<slug>.localhost:2405".
function deriveDomain() {
  const declared = window.__ENV__.APP_DOMAIN;
  if (declared) {
    return declared;
  }
  try {
    return new URL(APP_URL).host.replace(/^console\./, '');
  } catch {
    return 'hauser.md';
  }
}

export const APP_DOMAIN = deriveDomain();
